import React from 'react'
import "../Contact.css"
import { Grid2, Typography,Paper } from '@mui/material'
import Input from '../../../components/Input/Input'
import Button from '../../../components/Button/Button'
import "../Contact.css"
import exportsImage from "../../../assets/Home/international_exports.jpg"
import LocationOnIcon from '@mui/icons-material/LocationOn'

export function ContactConnectDesktop() {
  return (
    <Grid2 className="info">
    <Grid2 container  sx={{width:"95%",margin:"auto"}}>
   <Grid2  component={Paper}  className="connect" sx={{width:"65%",borderRadius:"30px"}}>
        <Typography className='header'>CONNECT WITH US</Typography>
        <Grid2 className="inputdata">
            <Grid2 className="nameemail">
            <Input placeholder="Full Name"/>
            <Input placeholder="Email Name"/>
            </Grid2>
            <Input placeholder="Mobile Number"/>
            <Input placeholder="Message"/>
            <Button label="SEND ENQUIRY"/>
        </Grid2>
   </Grid2>
    <Grid2  width="30%">
     <img  src={exportsImage}  style={{borderRadius:"30px"}} width="100%"  alt="" />
     </Grid2>
   </Grid2>
    <Grid2 container justifyContent="center" sx={{flexDirection:"column",alignItems:"center",width:"100%",position:"relative",marginTop:'50px'}}>
       <Typography className="headingdata">Our Offices</Typography>
      <Grid2 container justifyContent="space-evenly" width="95%">
       <Grid2 className="details">
      <Typography className="getintouch" variant='h2'><LocationOnIcon/> HYDERABAD</Typography>
       <Grid2 container gap="10px" flexDirection="column" >
           <Grid2 container gap="10px" >
                <Typography>
                Grow Beyond Global Business Pvt. Ltd.<br/>HIVE, 4th Floor, Vasista Bhavan,<br/> opp. lane to, DLF Cyber City,  <br/> Indira Nagar,Gachibowli, <br/>  Hyderabad, Telangana 500032</Typography>
           </Grid2>
       </Grid2>
      </Grid2>
      </Grid2>
     </Grid2>
    </Grid2>
  )
}

 